import { memo } from "react";
import { Button } from "@/shared/ui/button";
import { ChevronLeft, ChevronRight } from "lucide-react";

interface ImageDialogNavigationProps {
  canNavigatePrev: boolean;
  canNavigateNext: boolean;
  onNavigate: (direction: "prev" | "next") => void;
}

function ImageDialogNavigationComponent({
  canNavigatePrev,
  canNavigateNext,
  onNavigate,
}: ImageDialogNavigationProps) {
  return (
    <>
      {canNavigatePrev && (
        <Button
          variant="ghost"
          size="icon"
          className="absolute left-4 top-1/2 -translate-y-1/2 z-50 bg-black/50 hover:bg-white/70 text-white border border-white/20"
          onClick={() => onNavigate("prev")}
          aria-label="Previous image"
        >
          <ChevronLeft className="h-6 w-6" />
        </Button>
      )}

      {canNavigateNext && (
        <Button
          variant="ghost"
          size="icon"
          className="absolute right-4 top-1/2 -translate-y-1/2 z-50 bg-black/50 hover:bg-white/70 text-white border border-white/20"
          onClick={() => onNavigate("next")}
          aria-label="Next image"
        >
          <ChevronRight className="h-6 w-6" />
        </Button>
      )}
    </>
  );
}

export const ImageDialogNavigation = memo(ImageDialogNavigationComponent);
